module.exports = __webpack_public_path__ + "static/media/PoppinsBold.43346dab.woff2";